import { useCallback } from "react";
import { useRecoilState } from "recoil";
import { TrayUIAtom } from "MVVM/State/clipStatus";
import { useMyInTransitPolling } from "./Hooks/useMyInTransitPolling";
import { useClipStatusRegistry } from "./Hooks/useClipStatusRegistry";

export const ClipStatusViewModel = () => {
  const {
    inFlightClips,
    pollingActive,
    kickPulsePolling,
    dismissTerminal,
    dismissed,
  } = useMyInTransitPolling();

  const entries = useClipStatusRegistry(inFlightClips, dismissed);

  const [trayUI, setTrayUI] = useRecoilState(TrayUIAtom);

  const toggleTray = useCallback(() => {
    setTrayUI((prev) => ({ ...prev, expanded: !prev.expanded }));
  }, [setTrayUI]);

  return {
    entries,
    inFlightClips,
    pollingActive,
    trayExpanded: trayUI.expanded,
    toggleTray,
    dismissTerminal,
    dismissed,
    kickPulsePolling,
  };
};
